
import { ChapterDM, 
         PageDM, 
         ExerciseDM, 
         LinkDM, 
         QuestionDM, 
         ButtonDM, 
         HandleDM, 
         ZoomInitDM, 
         BlurifyDM, 
         WordDM, 
         PuzzleFindWordsDM, 
         LabelDM, 
         MainMenuDM,
         MainMenuItemDM, 
         BookDM,
         AudioVideoDM} from './datamodel';



export function prepareChapterDataModel(bookDM, chapterJs, chapterBasePath) {
   // console.log(chapterJs);
    if (chapterJs.chapter === undefined) {
        return null;
    }

    var chapterDM = new ChapterDM();

    if (chapterJs.config !== undefined) {
        let config = chapterJs.config;

        if (config.answerResultIndicatorSize !== undefined && config.answerResultIndicatorSize._text !== undefined) {
            chapterDM.config.answerResultIndicatorSize = +config.answerResultIndicatorSize._text;
        }

        if (config.drawingLineThickness !== undefined && config.drawingLineThickness._text !== undefined) {
            chapterDM.config.drawingLineThickness = +config.drawingLineThickness._text;
        }

        if (config.fontSize !== undefined && config.fontSize._text !== undefined) {
            chapterDM.config.fontSize = +config.fontSize._text;
        }
    } else {
        chapterDM.config = {
            ...bookDM.config
        }
    }


    let chapter = chapterJs.chapter;

    if (chapter.pages === undefined || chapter.pages.page === undefined) {
        return null;
    }

    if (!Array.isArray(chapter.pages.page)) {
        let tmp = chapter.pages.page;
        chapter.pages.page = [];
        chapter.pages.page.push(tmp);
    }

    let pages = chapter.pages.page; // XML behavior :-(



    chapterDM.pages = [];

    pages.forEach(page => {
        let pageDM = new PageDM();


        if (page.config !== undefined) {
            let config = page.config;
    
            if (config.answerResultIndicatorSize !== undefined && config.answerResultIndicatorSize._text !== undefined) {
                pageDM.config.answerResultIndicatorSize = +config.answerResultIndicatorSize._text;
            }
    
            if (config.drawingLineThickness !== undefined && config.drawingLineThickness._text !== undefined) {
                pageDM.config.drawingLineThickness = +config.drawingLineThickness._text;
            }
    
            if (config.fontSize !== undefined && config.fontSize._text !== undefined) {
                pageDM.config.fontSize = +config.fontSize._text;
            }
        } else {
            pageDM.config = {
                ...chapterDM.config
            }
        }

        pageDM.basePath = chapterBasePath;
        if (page.pageimage !== undefined && page.pageimage._text !== undefined) {
            pageDM.pageUrl = page.pageimage._text;
        }

        if (page.pagenumber !== undefined && page.pagenumber._text !== undefined) {
            pageDM.pageNumberRange = page.pagenumber._text;
        }

        if (page.words !== undefined && page.words.button !== undefined) {
            pageDM.words = null;
        }

        if (page.text !== undefined && page.text._text !== undefined) {
            pageDM.text = normalizeQuotations(page.text._text);
        }

        if (page.sentence !== undefined && page.sentence._text !== undefined) {
            pageDM.sentence = normalizeQuotations(page.sentence._text);
        }

        // parse page audios
        if (page.audios !== undefined && page.audios.audio !== undefined) {
            if (!Array.isArray(page.audios.audio)) {
                let tmp = page.audios.audio;
                page.audios.audio = [];
                page.audios.audio.push(tmp);
            }

            page.audios.audio.forEach(audio => {

                let audioVideoDM = new AudioVideoDM();
                if (audio._attributes.title !== undefined) {
                    audioVideoDM.title = audio._attributes.title;
                }
                if (audio._attributes.audiofile !== undefined) {
                    audioVideoDM.src = `${pageDM.basePath}/${audio._attributes.audiofile}`;
                }
                if (audio._attributes.autoplay !== undefined) {
                    if (audio._attributes.autoplay === 'true') {
                        audioVideoDM.autoplay = true;
                    } else {
                        audioVideoDM.autoplay = false;
                    }
                }
                

                pageDM.audios.push(audioVideoDM);

            });


        }

        // parse page videos
        if (page.videos !== undefined && page.videos.video) {
            if (!Array.isArray(page.videos.video)) {
                let tmp = page.videos.video;
                page.videos.video = [];
                page.videos.video.push(tmp);
            }

            page.videos.video.forEach(video => {

                let audioVideoDM = new AudioVideoDM();
                if (video._attributes.title !== undefined) {
                    audioVideoDM.title = video._attributes.title;
                }
                if (video._attributes.videofile !== undefined) {
                    audioVideoDM.src = `${pageDM.basePath}/${video._attributes.videofile}`;
                }
                if (video._attributes.autoplay !== undefined) {
                    if (video._attributes.autoplay === 'true') {
                        audioVideoDM.autoplay = true;
                    } else {
                        audioVideoDM.autoplay = false;
                    }
                }
                
                pageDM.videos.push(audioVideoDM);

            });

        }


        if (page.links !== undefined && page.links.link !== undefined) {
            pageDM.links = [];

            if (!Array.isArray(page.links.link)) {
                let link = page.links.link;
                page.links.link = [];
                page.links.link.push(link);
            }

            let links = page.links.link;
            links.forEach(link => {
                let linkDM = new LinkDM();

                // parse link handle
                if (link.handle !== undefined && link.handle._attributes !== undefined) {
                    let handleAttr = link.handle._attributes;
                    if (handleAttr.x1 !== undefined && handleAttr.y1 !== undefined 
                        && handleAttr.x2 !== undefined && handleAttr.y2 !== undefined) {
                            let handleDM = new HandleDM();
                            handleDM.setX1Y1X2Y2(+handleAttr.x1, +handleAttr.y1, +handleAttr.x2, +handleAttr.y2);
                            linkDM.handle = handleDM;
                    }
                }

                // parse link url 
                if (link.url !== undefined && link.url._text !== undefined) {
                    linkDM.url =  link.url._text.trim();
                }

                pageDM.links.push(linkDM);

            });

        }


        if (page.exercises !== undefined && page.exercises.exercise !== undefined) {
            pageDM.exercises = [];

            if (!Array.isArray(page.exercises.exercise)) {
                let exercise = page.exercises.exercise;
                page.exercises.exercise = [];
                page.exercises.exercise.push(exercise);
            }

            let exercises = page.exercises.exercise;
            exercises.forEach(exercise => {
                let exerciseDM = new ExerciseDM();

                if (exercise._attributes !== undefined && exercise._attributes.answerResultIndicatorSize) {
                    exerciseDM.config.answerResultIndicatorSize = +exercise._attributes.answerResultIndicatorSize;
                } else {
                    exerciseDM.config.answerResultIndicatorSize = pageDM.config.answerResultIndicatorSize;
                }

                if (exercise._attributes !== undefined && exercise._attributes.fontSize) {
                    exerciseDM.config.fontSize = +exercise._attributes.fontSize;
                } else {
                    exerciseDM.config.fontSize = pageDM.config.fontSize;
                }

                if (exercise._attributes !== undefined && exercise._attributes.drawingLineThickness) {
                    exerciseDM.config.drawingLineThickness = +exercise._attributes.drawingLineThickness;
                } else {
                    exerciseDM.config.drawingLineThickness = pageDM.config.drawingLineThickness;
                }


                // parse exercise handle
                if (exercise.handle !== undefined && exercise.handle._attributes !== undefined) {
                    let handleAttr = exercise.handle._attributes;
                    if (handleAttr.x1 !== undefined && handleAttr.y1 !== undefined 
                        && handleAttr.x2 !== undefined && handleAttr.y2 !== undefined) {
                            let exerciseHandleDM = new HandleDM();
                            exerciseHandleDM.setX1Y1X2Y2(+handleAttr.x1, +handleAttr.y1, +handleAttr.x2, +handleAttr.y2);
                            exerciseDM.handle = exerciseHandleDM;
                        }
                }


                // parse exercise zoominit
                if (exercise.zoominit !== undefined) {

                    if (!Array.isArray(exercise.zoominit)) {
                        // convert single zoominit to array for standardizing purposes
                        let tmp = exercise.zoominit;
                        exercise.zoominit = [];
                        exercise.zoominit.push(tmp);
                    }

                    exercise.zoominit.forEach(zoominit => {
                        if (zoominit._attributes === undefined) {
                            return;
                        }
                        
                        let zoomInitAttr = zoominit._attributes;
                        let x1 = 0;
                        let y1 = 0;
                        let x2 = 0;
                        let y2 = 0;
                        
                        if (zoomInitAttr.x1 !== undefined) {
                            x1 = +zoomInitAttr.x1;
                        }
    
                        if (zoomInitAttr.y1 !== undefined) {
                            y1 = +zoomInitAttr.y1;
                        }
    
                        if (zoomInitAttr.x2 !== undefined) {
                            x2 = +zoomInitAttr.x2;
                        }
                        
                        if (zoomInitAttr.y2 !== undefined) {
                            y2 = +zoomInitAttr.y2;
                        }
    
                        let exerciseZoomInitDM = new ZoomInitDM();
                        exerciseZoomInitDM.setX1Y1X2Y2(x1, y1, x2, y2);
                        if (zoominit.blurify !== undefined) {
                            if (!Array.isArray(zoominit.blurify)) {
                                // convert single blurify to array for standardizing purposes
                                let tmp = zoominit.blurify;
                                zoominit.blurify = [];
                                zoominit.blurify.push(tmp);
                            }
    
                            zoominit.blurify.forEach(blurify => {
                                let blurifyAttr = blurify._attributes;
                                let bx1 = +blurifyAttr.x1 - 30;
                                let by1 = +blurifyAttr.y1 - 30; 
                                let bx2 = +blurifyAttr.x2 + 30;
                                let by2 = +blurifyAttr.y2 + 30;
    
                                if (bx1 < exerciseZoomInitDM.x) {
                                    bx1 = exerciseZoomInitDM.x;
                                }
                                if (by1 < exerciseZoomInitDM.y) {
                                    by1 = exerciseZoomInitDM.y;
                                }
    
                                if (bx2 > exerciseZoomInitDM.x + exerciseZoomInitDM.w) {
                                    bx2 = exerciseZoomInitDM.x + exerciseZoomInitDM.w;
                                }
                                if (by2 > exerciseZoomInitDM.y + exerciseZoomInitDM.h) {
                                    by2 = exerciseZoomInitDM.y + exerciseZoomInitDM.h;
                                }
    
                                let blurifyDM = new BlurifyDM();
                                blurifyDM.setX1Y1X2Y2(bx1, by1, bx2, by2);
                                exerciseZoomInitDM.blurifies.push(blurifyDM);
                            });
                        }

                        exerciseDM.zoomInits.push(exerciseZoomInitDM);
                    });

                }

                // parse exercise preload
                if (exercise.preload !== undefined && exercise.preload.label !== undefined) {
                    if (!Array.isArray(exercise.preload.label)) {
                        let label = exercise.preload.label;
                        exercise.preload.label = [];
                        exercise.preload.label.push(label);
                    }

                    exercise.preload.label.forEach(label => {
                        let labelDM = new LabelDM();

                        let x1;
                        let y1;
                        let x2;
                        let y2;
                        if (label._attributes.x1 !== undefined) {
                            x1 = +label._attributes.x1;
                        } else {
                            x1 = 0;
                        }
    
                        if (label._attributes.y1 !== undefined) {
                            y1 = +label._attributes.y1;
                        } else {
                            y1 = 0;
                        }
    
                        if (label._attributes.x2 !== undefined) {
                            x2 = +label._attributes.x2;
                        } else {
                            x2 = 80;
                        }
    
                        if (label._attributes.y2 !== undefined) {
                            y2 = +label._attributes.y2;
                        } else {
                            y2 = 80;
                        }
    
                        labelDM.setX1Y1X2Y2(x1, y1, x2, y2);

                        if (label._attributes.rotation !== undefined) {
                            labelDM.rotation = +label._attributes.rotation;
                        } else {
                            labelDM.rotation = 0;
                        }
                
                        if (label._attributes.align !== undefined) {
                            labelDM.align = label._attributes.align;
                        } else {
                            labelDM.align = 'center';
                        }
                
                        if (label._attributes.displayCase !== undefined) {
                            labelDM.displayCase = label._attributes.displayCase;
                        } else {
                            labelDM.displayCase = 'uppercase';
                        }

                        if (label._attributes.value !== undefined) {
                            labelDM.value = normalizeQuotations(label._attributes.value);
                        } else {
                            labelDM.value = '';
                        }
        
                        if (label._attributes.skip !== undefined && label._attributes.skip === 'true') {
                            labelDM.skip = true;
                        }

                        exerciseDM.preloadedLabels.push(labelDM);
                    });

                }


                // parse exercise audios
                if (exercise.audios !== undefined) {
                    if (!Array.isArray(exercise.audios.audio)) {
                        let tmp = exercise.audios.audio;
                        exercise.audios.audio = [];
                        exercise.audios.audio.push(tmp);
                    }

                    exercise.audios.audio.forEach(audio => {

                        let audioVideoDM = new AudioVideoDM();
                        if (audio._attributes.title !== undefined) {
                            audioVideoDM.title = audio._attributes.title;
                        }
                        if (audio._attributes.audiofile !== undefined) {
                            audioVideoDM.src = `${pageDM.basePath}/${audio._attributes.audiofile}`;
                        }
                        if (audio._attributes.autoplay !== undefined) {
                            if (audio._attributes.autoplay === 'true') {
                                audioVideoDM.autoplay = true;
                            } else {
                                audioVideoDM.autoplay = false;
                            }
                        }
                        

                        exerciseDM.audios.push(audioVideoDM);
                    });

 
                }

                // parse exercise videos
                if (exercise.videos !== undefined) {
                    if (!Array.isArray(exercise.videos.video)) {
                        let tmp = exercise.videos.video;
                        exercise.audvideosios.video = [];
                        exercise.videos.video.push(tmp);
                    }

                    exercise.videos.video.forEach(video => {

                        let audioVideoDM = new AudioVideoDM();
                        if (video._attributes.title !== undefined) {
                            audioVideoDM.title = video._attributes.title;
                        }
                        if (video._attributes.audiofile !== undefined) {
                            audioVideoDM.src = `${pageDM.basePath}/${video._attributes.videofile}`;
                        }
                        if (video._attributes.autoplay !== undefined) {
                            if (video._attributes.autoplay === 'true') {
                                audioVideoDM.autoplay = true;
                            } else {
                                audioVideoDM.autoplay = false;
                            }
                        }
                        
                        exerciseDM.videos.push(audioVideoDM);
                    });

                }
                
                // parse exercise questions
                if (exercise.question !== undefined) {

                    if (!Array.isArray(exercise.question)) {
                        let question = exercise.question;
                        exercise.question = [];
                        exercise.question.push(question);
                    }

                    // this exercise has array of questions
                    exercise.question.forEach((question, index) => {
                        let questionDM = prepareQuestionDM(exerciseDM, question, '' + index);
                        exerciseDM.questions.push(questionDM);
                    });
                }

                // parse exercise destination buttons
                if (exercise.destinations !== undefined && exercise.destinations.button !== undefined) {
                    if (!Array.isArray(exercise.destinations.button)) {
                        let button = exercise.destinations.button;
                        exercise.destinations.button = [];
                        exercise.destinations.button.push(button);
                    }
                    let buttonDMTmp = new ButtonDM(); // only to access TYPE_DESTINATION
                    exercise.destinations.button.forEach((button) => {
                        let buttonDM = prepareButtonDM(button, buttonDMTmp.TYPE_DESTINATION);
                        exerciseDM.destinationButtons.push(buttonDM);
                    });
                } 

                if (exercise.puzzlefindwords !== undefined) {
                    let pfwJsObj = exercise.puzzlefindwords;
                    let pfwDM = new PuzzleFindWordsDM();
                    
                    let x1;
                    let y1;
                    let x2;
                    let y2;
                    if (pfwJsObj._attributes.x1 !== undefined) {
                        x1 = +pfwJsObj._attributes.x1;
                    } else {
                        x1 = 0;
                    }
            
                    if (pfwJsObj._attributes.y1 !== undefined) {
                        y1 = +pfwJsObj._attributes.y1;
                    } else {
                        y1 = 0;
                    }
            
                    if (pfwJsObj._attributes.x2 !== undefined) {
                        x2 = +pfwJsObj._attributes.x2;
                    } else {
                        x2 = 80;
                    }
            
                    if (pfwJsObj._attributes.y2 !== undefined) {
                        y2 = +pfwJsObj._attributes.y2;
                    } else {
                        y2 = 80;
                    }
            
                    pfwDM.setX1Y1X2Y2(x1, y1, x2, y2);
            
        
                    if (pfwJsObj._attributes.rotation !== undefined) {
                        pfwDM.rotation = +pfwJsObj._attributes.rotation;
                    } else {
                        pfwDM.rotation = 0;
                    }
        
                    if (pfwJsObj._attributes.margin !== undefined) {
                        pfwDM.margin = +pfwJsObj._attributes.margin;
                    } else {
                        pfwDM.margin = 0;
                    }

                    if (pfwJsObj._attributes.rows !== undefined) {
                        pfwDM.rows = +pfwJsObj._attributes.rows;
                    } else {
                        pfwDM.rows = 0;
                    }
        

                    if (pfwJsObj._attributes.columns !== undefined) {
                        pfwDM.columns = +pfwJsObj._attributes.columns;
                    } else {
                        pfwDM.columns = 0;
                    }
        

                    let rows = pfwDM.rows;
                    let columns = pfwDM.columns;

                    let buttonDMs = []; // two dimentional array.
                    for (let row = 0; row < rows; row++) {
                        let btnCalculatedWidth = pfwDM.w / columns - pfwDM.margin;
                        let btnCalculatedHeight = pfwDM.h / rows - pfwDM.margin;
                        let rowArr = [];
                        for (let column = 0; column < columns; column++) {
                            let btnDM = new ButtonDM();
                            btnDM.x = column * (btnCalculatedWidth + pfwDM.margin);
                            btnDM.y = row * (btnCalculatedHeight + pfwDM.margin);
                            btnDM.w = btnCalculatedWidth;
                            btnDM.h = btnCalculatedHeight;

                            rowArr.push(btnDM); // a row dimention is prepared step by step with iterating columns
                        }
                        buttonDMs.push(rowArr); // the prepared row dimention is added to 2D array;
                    }


                    exerciseDM.questions.forEach(questionDMTmp => {
                        if (questionDMTmp.type !== 'find_the_words_puzzle') {
                            return;
                        }
                        questionDMTmp.words.forEach(word => {
                            buttonDMs[word.srcRow][word.srcCol].correctAnswers.push(word);
                        });
                    });



                    pfwDM.buttons = buttonDMs;

                    exerciseDM.puzzleFindWordsDM = pfwDM;
                    
                }
        

                pageDM.exercises.push(exerciseDM);
            });


            
        }

        chapterDM.pages.push(pageDM);
    });

    function prepareQuestionDM(exerciseDM, question, index) {
        let questionDM = new QuestionDM();


        if (question._attributes.sequence === undefined) {
            questionDM.sequence = '' + index;
        } else {
            questionDM.sequence = question._attributes.sequence;
        }

        if (question._attributes === undefined || question._attributes.type === undefined) {
            questionDM.type = 'circle_the_correct_one';
        } else {
            questionDM.type = question._attributes.type;
        }

        if (question._attributes === undefined || question._attributes.alternateValues === undefined) {
            let alternateValuesStr = '';
            if (questionDM.type === 'write_t_or_f' || questionDM.type === 'write_from_selection_box') {
                alternateValuesStr = 'T|F';
            } else if (questionDM.type === 'write_true_or_false') {
                alternateValuesStr = 'True|False';
            } else if (questionDM.type === 'write_y_or_n') {
                alternateValuesStr = 'Y|N';
            } else if (questionDM.type === 'write_yes_or_no') {
                alternateValuesStr = 'Yes|No';
            } else if (questionDM.type === 'write_tick_or_cross') {
                alternateValuesStr = 'P|O';
            } else {
                alternateValuesStr = 'T|F';
            }
            questionDM.alternateValues = alternateValuesStr.split('|');
        } else {
            let alternateValuesStr = question._attributes.alternateValues;
            questionDM.alternateValues = alternateValuesStr.split('|');
        }

        if (question._attributes === undefined || question._attributes.alternateLabels === undefined) {
            questionDM.alternateLabels = questionDM.alternateValues;
        } else {
            let alternateLabelsStr = question._attributes.alternateLabels;
            questionDM.alternateLabels = alternateLabelsStr.split('|');
        }

        if (question._attributes === undefined || question._attributes.selectionBoxFontSize === undefined) {
            questionDM.selectionBoxFontSize = 32;
        } else {
            let selectionBoxFontSizeStr = question._attributes.selectionBoxFontSize;
            questionDM.selectionBoxFontSize = +selectionBoxFontSizeStr;
        }

        questionDM.buttons = []; // initialize it as an empty array
        if (question.button !== undefined) {
            if (!Array.isArray(question.button)) {
                let btn = question.button;
                question.button = [];
                question.button.push(btn);
            }
            question.button.forEach(button => {
                let buttonDMTmp = new ButtonDM(); // only to access TYPE_SOURCE
                let buttonDM = prepareButtonDM(button, buttonDMTmp.TYPE_SOURCE);
                questionDM.buttons.push(buttonDM);
            });
        }

        questionDM.groupingAnswers = []; // initialize it as an empty array
        if (question.answer !== undefined) {
            if (!Array.isArray(question.answer)) {
                let answer = question.answer;
                question.answer = [];
                question.answer.push(answer);
            }
            question.answer.forEach(answer => {
                questionDM.groupingAnswers.push(normalizeQuotations(answer._text));
            });
        }


        questionDM.words = []; // initialize it as an empty array
        if (question.word !== undefined) {
            if (!Array.isArray(question.word)) {
                let wrd = question.word;
                question.word = [];
                question.word.push(wrd);
            }
            question.word.forEach(word => {
                let wordDM = prepareWordDM(word);
                questionDM.words.push(wordDM);
            });
        }

        return questionDM;
    }


    function prepareWordDM(word) {
        let wordDM = new WordDM();

        if (word._attributes.startbutton !== undefined) {
            wordDM.setStartButton(word._attributes.startbutton);
        } else {
            wordDM.setStartButton(0, 0);
        }

        if (word._attributes.endbutton !== undefined) {
            wordDM.setEndButton(word._attributes.endbutton);
        } else {
            wordDM.setEndButton(0, 0);
        }

        if (word._attributes.value !== undefined) {
            wordDM.value = word._attributes.value;
        } else {
            wordDM.value = 'E'; // means error
        }

        return wordDM;
    }


    function prepareButtonDM(button, btnType) {
        let buttonDM = new ButtonDM();

        let x1;
        let y1;
        let x2;
        let y2;
        if (button._attributes.x1 !== undefined) {
            x1 = +button._attributes.x1;
        } else {
            x1 = 0;
        }

        if (button._attributes.y1 !== undefined) {
            y1 = +button._attributes.y1;
        } else {
            y1 = 0;
        }

        if (button._attributes.x2 !== undefined) {
            x2 = +button._attributes.x2;
        } else {
            x2 = 80;
        }

        if (button._attributes.y2 !== undefined) {
            y2 = +button._attributes.y2;
        } else {
            y2 = 80;
        }

        buttonDM.setX1Y1X2Y2(x1, y1, x2, y2);


        let targetx1;
        let targety1;
        let targetx2;
        let targety2;
        if (button._attributes.targetx1 !== undefined) {
            targetx1 = +button._attributes.targetx1;
        } else {
            targetx1 = x1;
        }

        if (button._attributes.targety1 !== undefined) {
            targety1 = +button._attributes.targety1;
        } else {
            targety1 = y1;
        }

        if (button._attributes.targetx2 !== undefined) {
            targetx2 = +button._attributes.targetx2;
        } else {
            targetx2 = x2;
        }

        if (button._attributes.targety2 !== undefined) {
            targety2 = +button._attributes.targety2;
        } else {
            targety2 = y2;
        }

        buttonDM.setTargetX1Y1X2Y2(targetx1, targety1, targetx2, targety2);


        if (button._attributes.isCorrect !== undefined) {
            if (button._attributes.isCorrect === 'true') {
                buttonDM.correctAnswers.push('true');
            } else if (button._attributes.isCorrect === 'false') {
                buttonDM.correctAnswers.push('false');
            }    
        }


        if (button._attributes.rotation !== undefined) {
            buttonDM.rotation = +button._attributes.rotation;
        } else {
            buttonDM.rotation = 0;
        }

        if (button._attributes.targetrotation !== undefined) {
            buttonDM.targetRotation = +button._attributes.targetrotation;
        } else {
            buttonDM.targetRotation = 0;
        }

        if (button._attributes.align !== undefined) {
            buttonDM.align = button._attributes.align;
        } else {
            buttonDM.align = 'center';
        }

        if (button._attributes.displayCase !== undefined) {
            buttonDM.displayCase = button._attributes.displayCase;
        } else {
            buttonDM.displayCase = 'uppercase';
        }


        let counter = 1;
        let buttonAttrs = button._attributes;
        Object.keys(buttonAttrs).forEach(key => {
            if (key === 'correctAnswer') {
                buttonDM.correctAnswers.push(normalizeQuotations(buttonAttrs[key]));
            } else if (key === ('correctAnswer' + counter)) {
                buttonDM.correctAnswers.push(normalizeQuotations(buttonAttrs[key]));
                counter++;
            }
        });


        // set match_words_to_make_sentence button id
        if (button._attributes.id !== undefined) {
            buttonDM.id = button._attributes.id;
            buttonDM.value = buttonDM.id;
        } else {
            buttonDM.id = null;
        }

        // set match_words_to_make_sentence button nextbtns
        if (button._attributes.nextbtns !== undefined) {
            buttonDM.nextbtns = button._attributes.nextbtns;
            buttonDM.nextbtnsarray = buttonDM.nextbtns.split(',');
        } else {
            buttonDM.nextbtns = null;
        }
        

        // set destination button value  
        if (button._attributes.value !== undefined) {
            if (buttonDM.id !== null) {
                // this is a button for match_words_to_make_sentence
                // use id as value (have a look at id parsing) and real value goes to fictiveValue
                buttonDM.fictiveValue = normalizeQuotations(button._attributes.value);
            } else {
                buttonDM.value = normalizeQuotations(button._attributes.value);
            }
        } else {
            buttonDM.value = null;
        }

        // set button type
        if (btnType === buttonDM.TYPE_DESTINATION) {
            buttonDM.type = buttonDM.TYPE_DESTINATION;
        } else {
            buttonDM.type = buttonDM.TYPE_SOURCE;
        }

        // set coloring paths if any
        if (button.path !== undefined) {
            let minX = 100000;
            let minY = 100000;
            let maxX = 0;
            let maxY = 0;
            button.path.forEach(path => {
                let x = 0;
                let y = 0;
                if (path._attributes.x !== undefined) {
                    x = +path._attributes.x;
                }
                if (path._attributes.y !== undefined) {
                    y = +path._attributes.y;
                }
                let point = {
                    x: x,
                    y: y
                };
                if (x < minX) {
                    minX = x;
                }
                if (y < minY) {
                    minY = y;
                }
                if (x > maxX) {
                    maxX = x;
                }
                if (y > maxY) {
                    maxY = y;
                }
                buttonDM.pathModels.push(point);
            });

            buttonDM.setX1Y1X2Y2(minX, minY, maxX, maxY);

        }

        // set crossword puzzle labels if any
        if (button.label !== undefined) {
            buttonDM.labelModels = [];

            if (!Array.isArray(button.label)) {
                let tmp = button.label;
                button.label = [];
                button.label.push(tmp);
            }

            button.label.forEach(labelTmp => {
                let labelAttrs = labelTmp._attributes;
                let labelDM = new LabelDM();

                let x1;
                let y1;
                let x2;
                let y2;
                if (labelAttrs.x1 !== undefined) {
                    x1 = +labelAttrs.x1;
                } else {
                    x1 = 0;
                }
        
                if (labelAttrs.y1 !== undefined) {
                    y1 = +labelAttrs.y1;
                } else {
                    y1 = 0;
                }
        
                if (labelAttrs.x2 !== undefined) {
                    x2 = +labelAttrs.x2;
                } else {
                    x2 = 80;
                }
        
                if (labelAttrs.y2 !== undefined) {
                    y2 = +labelAttrs.y2;
                } else {
                    y2 = 80;
                }
                labelDM.setX1Y1X2Y2(x1, y1, x2, y2);


                if (labelAttrs.rotation !== undefined) {
                    labelDM.rotation = +labelAttrs.rotation;
                } else {
                    labelDM.rotation = 0;
                }


                labelDM.value = normalizeQuotations(labelAttrs.value);
                if (labelAttrs.skip !== undefined && labelAttrs.skip === 'true') {
                    labelDM.skip = true;
                }
                labelDM.value = labelAttrs.value;

                buttonDM.labelModels.push(labelDM);
            });
        }

        return buttonDM;
    }

    return chapterDM;
}


export function prepareMainMenuDataModel(mainMenuJS) {
    if (mainMenuJS.mainmenu === undefined) {
        return null;
    }

    let mainMenuDM = new MainMenuDM();

    let mainmenu = mainMenuJS.mainmenu;

    if (mainmenu.config !== undefined) {
        let config = mainmenu.config;

        if (config.appname !== undefined && config.appname._text !== undefined) {
            mainMenuDM.appInfo.name = config.appname._text;
        }

        if (config.appversion !== undefined && config.appversion._text !== undefined) {
            mainMenuDM.appInfo.version = config.appversion._text;
        }

        if (config.basepath !== undefined && config.basepath._text !== undefined) {
            mainMenuDM.basePath = config.basepath._text;
        }

        if (config.backgroundimage !== undefined && config.backgroundimage._text !== undefined) {
            mainMenuDM.mainMenuDecoration.backgroundImage = config.backgroundimage._text;
        }

        if (config.backgroundlogo !== undefined && config.backgroundlogo._text !== undefined) {
            mainMenuDM.mainMenuDecoration.backgroundMasterLogo = config.backgroundlogo._text;
        }

        if (config.titlebarbgcolor !== undefined && config.titlebarbgcolor._text !== undefined) {
            mainMenuDM.mainMenuDecoration.titlebarBgColor = config.titlebarbgcolor._text;
        }

        if (config.titlebarcontentcolor !== undefined && config.titlebarcontentcolor._text !== undefined) {
            mainMenuDM.mainMenuDecoration.titlebarContentColor = config.titlebarcontentcolor._text;
        }

    }

    if (mainmenu.items === undefined) {
        return mainMenuDM;
    }

    let items = mainmenu.items;

    if (items.item !== undefined && !Array.isArray(items.item)) {
        let tmp = items.item;
        items.item = [];
        items.item.push(tmp);
    }

    items.item.forEach(item => {
        let itemDM = new MainMenuItemDM();

        itemDM.basePath = mainMenuDM.basePath;

        if (item._text !== undefined) {
            itemDM.title = item._text;
        }

        if (item._attributes === undefined) {
            mainMenuDM.items.push(itemDM);
            return null;
        }
        
        let attr = item._attributes;
        if (attr.id !== undefined) {
            itemDM.id = attr.id;
        }

        if (attr.state !== undefined) {
            itemDM.type = attr.state;
        }

        if (attr.configfile !== undefined) {
            itemDM.configxml = attr.configfile;
        }

        mainMenuDM.items.push(itemDM);
    });

    mainMenuDM.isLoaded = true;
    return mainMenuDM;
}

export function prepareBookDataModel(bookJS) {
    if (bookJS.book === undefined) {
        return null;
    }

    let bookDM = new BookDM();
    let book = bookJS.book;

    if (book.authors !== undefined && book.authors._text !== undefined) {
        bookDM.authors = book.authors._text;
    }

    if (book.isbn !== undefined && book.isbn._text !== undefined) {
        bookDM.isbn = book.isbn._text;
    }

    if (book.title !== undefined && book.title._text !== undefined) {
        bookDM.title = book.title._text;
    }

    bookDM.isLoaded = true;
    if (book.config === undefined) {
        return bookDM;
    }

    if (book.config !== undefined) {
        let config = book.config;

        if (config.bookAnswerResultIndicatorSize !== undefined && config.bookAnswerResultIndicatorSize._text !== undefined) {
            bookDM.config.answerResultIndicatorSize = +config.bookAnswerResultIndicatorSize._text;
        }

        if (config.answerResultIndicatorSize !== undefined && config.answerResultIndicatorSize._text !== undefined) {
            bookDM.config.answerResultIndicatorSize = +config.answerResultIndicatorSize._text;
        }

        if (config.bookDrawingLineThickness !== undefined && config.bookDrawingLineThickness._text !== undefined) {
            bookDM.config.drawingLineThickness = +config.bookDrawingLineThickness._text;
        }

        if (config.drawingLineThickness !== undefined && config.drawingLineThickness._text !== undefined) {
            bookDM.config.drawingLineThickness = +config.drawingLineThickness._text;
        }

        if (config.bookFontSize !== undefined && config.bookFontSize._text !== undefined) {
            bookDM.config.fontSize = +config.bookFontSize._text;
        }

        if (config.fontSize !== undefined && config.fontSize._text !== undefined) {
            bookDM.config.fontSize = +config.fontSize._text;
        }

        if (config.flashcardMode !== undefined && config.flashcardMode._text !== undefined && config.flashcardMode._text === 'true') {
            bookDM.config.flashcardMode = true;
        }

        
    }



    if (book.chapters !== undefined && book.chapters.chapter !== undefined && !Array.isArray(book.chapters.chapter)) {
        let tmp = book.chapters.chapter;
        book.chapters.chapter = [];
        book.chapters.chapter.push(tmp);
    }

    let chapters = book.chapters.chapter;

    chapters.forEach(chapter => {
        let chapterDM = new ChapterDM();

        if (chapter.configfile !== undefined && chapter.configfile._text !== undefined) {
            chapterDM.configxml = chapter.configfile._text;
        }

        if (chapter.pagenumbers !== undefined && chapter.pagenumbers._text !== undefined) {
            chapterDM.pageNumberRange = chapter.pagenumbers._text;
        }

        if (chapter.title !== undefined && chapter.title._text !== undefined) {
            chapterDM.title = chapter.title._text;
        }

        bookDM.chapters.push(chapterDM);
    });

    return bookDM;

}


function normalizeQuotations(value) {
    if (value === null || value === undefined) {
        return null;
    }

    let normalizedValue = value;
    let regex = /’/g;
    normalizedValue = normalizedValue.replaceAll(regex, '\'');
    regex = /‘/g;
    normalizedValue = normalizedValue.replaceAll(regex, '\'');
    regex = /”/g;
    normalizedValue = normalizedValue.replaceAll(regex, '"');
    regex = /“/g;
    normalizedValue = normalizedValue.replaceAll(regex, '"');
    return normalizedValue;
}

